import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { PayrollStructureUnitListSearchSchema } from '../-shared/payroll-structure-unit-list-search-schema';
export const Route = createFileRoute('/_staff/payroll-engine-mock/_layout/payroll-units/')({
  validateSearch: zodValidator(PayrollStructureUnitListSearchSchema)
});